import React, { createContext, useState, useContext } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

// Create context
const ErrorDialogContext = createContext();

export const ErrorDialogProvider = ({ children }) => {
  const [message, setMessage] = useState("");

  const [open, setOpen] = useState(false);
  const showMsg = (errorMsg) => {
    setMessage(errorMsg);
    setOpen(true);
  };
  const closeMsg = () => {
    setOpen(false);
    setMessage("");
  };

  const [openError, setOpenError] = useState(false);
  const showError = (errorMsg) => {
    setMessage(errorMsg);
    setOpenError(true);
  };
  const closeError = () => {
    setOpenError(false);
    setMessage("");
  };

  return (
    <ErrorDialogContext.Provider value={{ showMsg, showError }}>
      {children}
      <Dialog open={open} onClose={closeMsg}>
        <DialogTitle>Erfolgreich</DialogTitle>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
          <Button onClick={closeMsg} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openError} onClose={closeError}>
        <DialogTitle>Fehler</DialogTitle>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
          <Button onClick={closeError} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </ErrorDialogContext.Provider>
  );
};

// Custom hook to use error dialog
export const useErrorDialog = () => useContext(ErrorDialogContext);